import { useTranslation } from 'react-i18next';
import { InfiosAlert, InfiosButton, InfiosIcon } from '@infios/uikit/react';
import type { ActionRef } from '../../interfaces/chat';
import { useReferenceAction } from '../../context/ReferenceActionContext';
import styles from './NoViableOptionNotice.module.css';

interface NoViableOptionNoticeProps {
  escalateToCsr?: ActionRef;
}

/**
 * Renders when `recommendations.length === 0` (invariant #5) instead of an
 * empty resolution-options section. Always surfaces `actions.escalateToCsr`
 * when present, per the design doc's stated fallback rule.
 */
export function NoViableOptionNotice({ escalateToCsr }: NoViableOptionNoticeProps) {
  const { t } = useTranslation();
  const onReference = useReferenceAction();

  return (
    <InfiosAlert
      variant="danger"
      open
      className={styles.wrap}
      actionsPlacement="footer"
      data-testid="no-viable-option"
    >
      <InfiosIcon slot="icon" name="alert-circle" />
      <span className={styles.title}>{t('ChatbotUI.OrderInsight.NoViableOptionTitle')}</span>
      <p className={styles.body}>{t('ChatbotUI.OrderInsight.NoViableOptionBody')}</p>
      {escalateToCsr ? (
        <InfiosButton
          slot="action"
          variant="secondary"
          size="compact"
          className={styles.escalateBtn}
          onClick={() => onReference?.(escalateToCsr.reference)}
        >
          {escalateToCsr.label}
        </InfiosButton>
      ) : null}
    </InfiosAlert>
  );
}
